import React, { useState } from "react";
import { Cascader, Input, Button, Space } from "antd";
import "./NumericFilter.scss";

const operatorOptions = [
  { value: "=", label: "=" },
  { value: "!=", label: "!=" },
  { value: "<", label: "<" },
  { value: "<=", label: "<=" },
  { value: ">", label: ">" },
  { value: ">=", label: ">=" },
  { value: "between", label: "between" },
];

const fields = [
  { value: "totalExp", label: "Total Experience" },
  { value: "relevantExp", label: "Relevant Experience" },
  { value: "currentCTC", label: "Current CTC" },
  { value: "eCTC", label: "ECTC" },
  { value: "noticePeriod", label: "Notice Period" },
];

const buildOptions = () =>
  fields.map((field) => ({
    ...field,
    children: operatorOptions.map((op) => ({
      ...op,
      isLeaf: false,
    })),
  }));

export default function NumericFilter() {
  const [filters, setFilters] = useState([]);
  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");

  const handleSelect = (path) => {
    if (path.length === 2) return; // wait for value input

    const [field, operator] = path;
    setFilters([
      ...filters,
      {
        field,
        operator,
        value1,
        value2,
      },
    ]);
    setValue1("");
    setValue2("");
  };

  return (
    <div className="resumes-expression-filter">
      <Cascader
        options={buildOptions()}
        placeholder="Expression filter"
        dropdownRender={(menus) => (
          <div>
            {menus}
            <div style={{ padding: 8 }}>
              <Space>
                <Input
                  placeholder="Value"
                  value={value1}
                  onChange={(e) => setValue1(e.target.value)}
                />
                <Input
                  placeholder="And"
                  value={value2}
                  onChange={(e) => setValue2(e.target.value)}
                />
              </Space>
            </div>
          </div>
        )}
        onChange={handleSelect}
      />
    </div>
  );
}
